import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../components/AppShell';
import api, { resolveAvatarUrl } from '../api';

/**
 * My Clans — every Clan the user holds ≥1 Bit in. Phase 4.
 * Sorted by bits_owned desc. Direct-links into /clan/{h}/feed for members, /creator/{h} otherwise.
 */
export default function MyClans() {
  const navigate = useNavigate();
  const [clans, setClans] = useState(null);

  useEffect(() => {
    api.get('/my-clans').then(({ data }) => setClans(data.clans || [])).catch(() => setClans([]));
  }, []);

  return (
    <AppShell activeTab="home">
      <div className="mycl-wrap" data-testid="my-clans-page">
        <h1 className="mycl-title">My Clans</h1>
        <p className="mycl-sub">Every Clan you hold Bits in. Members unlock the private Feed + Chat.</p>

        {clans === null && <div className="notif-loading" data-testid="mycl-loading">loading…</div>}

        {clans && clans.length === 0 && (
          <div className="notif-empty" data-testid="mycl-empty">
            <div className="notif-empty-emoji">🎯</div>
            <div className="notif-empty-title">No Clans yet</div>
            <p className="notif-empty-sub">Buy a Bit to join your first Clan.</p>
            <button className="mycl-cta" onClick={() => navigate('/home')} data-testid="mycl-empty-cta">
              Browse creators
            </button>
          </div>
        )}

        {clans && clans.length > 0 && (
          <div className="mycl-list" data-testid="mycl-list">
            {clans.map((c) => {
              const up = c.pnl_abs >= 0;
              const canEnter = c.is_member || c.is_creator;
              const target = canEnter ? `/clan/${c.handle}/feed` : `/creator/${c.handle}`;
              return (
                <div
                  className="mycl-card"
                  key={c.handle}
                  onClick={() => navigate(target, { state: { from: '/my-clans' } })}
                  role="button"
                  tabIndex={0}
                  data-testid={`mycl-card-${c.handle}`}
                >
                  <div className="mycl-head">
                    <div
                      className="mycl-avatar"
                      style={{ background: `linear-gradient(135deg, ${c.gradient[0]}, ${c.gradient[1]})` }}
                    >
                      {c.avatar ? (
                        <img
                          src={resolveAvatarUrl(c.avatar)}
                          alt=""
                          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }}
                        />
                      ) : c.initials}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="mycl-name">{c.display_name}</div>
                      <div className="mycl-handle">
                        @{c.handle}
                        {c.categories?.[0] && <span className="mycl-cat">· {c.categories[0]}</span>}
                        {c.is_creator && <span className="mycl-tag creator">Creator</span>}
                        {!c.is_creator && c.is_member && <span className="mycl-tag member">Member</span>}
                        {!c.is_creator && !c.is_member && <span className="mycl-tag locked">Locked</span>}
                        {c.is_paused && <span className="mycl-tag paused">Paused</span>}
                      </div>
                    </div>
                  </div>

                  <div className="mycl-stats">
                    <div>
                      <div className="mycl-stat-label">Holding</div>
                      <div className="mycl-stat-value">{c.bits_owned} Bit{c.bits_owned === 1 ? '' : 's'}</div>
                    </div>
                    <div>
                      <div className="mycl-stat-label">Value</div>
                      <div className="mycl-stat-value">{c.market_value.toFixed(2)} pts</div>
                    </div>
                    <div>
                      <div className="mycl-stat-label">P&amp;L</div>
                      <div className={`mycl-stat-value ${up ? 'pos' : 'neg'}`}>
                        {up ? '+' : '−'}{Math.abs(c.pnl_abs).toFixed(2)} ({Math.abs(c.pnl_pct).toFixed(1)}%)
                      </div>
                    </div>
                  </div>

                  {!c.is_creator && !c.is_member && (
                    <div className="mycl-locked-note">
                      🔒 Hold {c.min_bits_to_join} Bits to unlock the private Feed
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </AppShell>
  );
}
